import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = { class: "create-package-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "dashboard-header" }, [
      _createElementVNode("h2", { class: "title-main" }, "Create Package")
    ], -1)),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["ProjectDropdown"], {
        estateSelected: $setup.estateSelected,
        options: $setup.optionsEstate,
        onSelectEstate: $setup.onSelectEstate
      }, null, 8, ["estateSelected", "options"]),
      ($setup.selectedEstateId && !$setup.openListLots)
        ? (_openBlock(), _createBlock($setup["AdminEstateStages"], {
            key: 0,
            estateId: $setup.selectedEstateId,
            landownerId: $setup.selectedLandownerId,
            isConciergeView: true,
            onToLots: $setup.onToLots
          }, null, 8, ["estateId", "landownerId"]))
        : _createCommentVNode("", true),
      ($setup.selectedStageId && $setup.openListLots)
        ? (_openBlock(), _createBlock($setup["AdminStageLots"], {
            key: 1,
            estateId: $setup.selectedEstateId,
            landownerId: $setup.selectedLandownerId,
            stageId: $setup.selectedStageId,
            isConciergeView: true,
            onLotSelected: $setup.onLotSelected
          }, null, 8, ["estateId", "landownerId", "stageId"]))
        : _createCommentVNode("", true),
      ($setup.openBuilderDrop)
        ? (_openBlock(), _createBlock($setup["BuilderDropdown"], {
            key: 2,
            builderPackage: $setup.builderPackage,
            builders: $setup.builderOptions,
            onSelectBuilder: $setup.onSelectBuilder
          }, null, 8, ["builderPackage", "builders"]))
        : _createCommentVNode("", true),
      ($setup.builderPackage && $setup.openHouseTable)
        ? (_openBlock(), _createBlock($setup["HouseTable"], {
            key: 3,
            houses: $setup.selectedBuilderHouses,
            onSelectHouse: $setup.onSelectHouse
          }, null, 8, ["houses"]))
        : _createCommentVNode("", true),
      ($setup.housePackage && $setup.openFacadeOptions)
        ? (_openBlock(), _createBlock($setup["FacadeOptions"], {
            key: 4,
            facades: $setup.selectedHouseFacades,
            onSelectFacade: $setup.onSelectFacade
          }, null, 8, ["facades"]))
        : _createCommentVNode("", true),
      ($setup.housePackage && $setup.selectedHouseFacades && $setup.openAddSiteCosts)
        ? (_openBlock(), _createBlock($setup["AddSiteCosts"], {
            key: 5,
            siteCosts: $setup.selectedHouseSiteCosts,
            onAddSiteCosts: $setup.onAddSiteCosts
          }, null, 8, ["siteCosts"]))
        : _createCommentVNode("", true),
      ($setup.housePackage && $setup.selectedHouseFacades && $setup.openAddSiteCosts)
        ? (_openBlock(), _createBlock($setup["SummaryPackage"], {
            key: 6,
            project: $setup.estateSelected,
            lot: $setup.lotPackage.name,
            landSize: $setup.lotSelectedSize,
            landPrice: $setup.lotPackage.price,
            homeArea: $setup.selectedHouseArea,
            homePrice: $setup.housePackage.price,
            facadePrice: $setup.facadePackage.price,
            siteCosts: $setup.selectedSiteCosts
          }, null, 8, ["project", "lot", "landSize", "landPrice", "homeArea", "homePrice", "facadePrice", "siteCosts"]))
        : _createCommentVNode("", true),
      ($setup.housePackage && $setup.selectedHouseFacades && $setup.openAddSiteCosts)
        ? (_openBlock(), _createBlock($setup["SavedChanges"], {
            key: 7,
            landSize: $setup.lotSelectedSize,
            siteCosts: $setup.selectedSiteCosts,
            builderPackage: $setup.builderPackage,
            housePackage: $setup.housePackage,
            facadePackage: $setup.facadePackage,
            floorplanPackage: $setup.floorplanPackage,
            lotPackage: $setup.lotPackage,
            landowerId: $setup.selectedLandownerId,
            estateId: $setup.selectedEstateId,
            estateTitle: $setup.estateSelected
          }, null, 8, ["landSize", "siteCosts", "builderPackage", "housePackage", "facadePackage", "floorplanPackage", "lotPackage", "landowerId", "estateId", "estateTitle"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}